
import Vue from "vue";
import SignatureLayout from "@/components/common/SignatureLayout.vue";
import ChangeKennelOwners from "@/components/Portal/MyRequest/ChangeKennelOwners.vue";
import KennelSignatureText from "@/components/common/KennelSignatureText.vue";

import { UserInfo } from "@/types/User";
import workflowService from "@/services/portal/workflowService";

export default Vue.extend({
  name: "ChangeKennelOwnersSignature",
  components: {
    SignatureLayout,
    ChangeKennelOwners,
    KennelSignatureText,
  },
  props: { signatureId: Number },
  data: function () {
    return {
      signatureText: "",
      errorMessage: "",
      registration: Object,
      isLoading: false,
      found: false,
      rulesDialog: false,
    };
  },
  created() {
    this.load();
  },
  watch: {
    signatureId: function (newValue) { this.load(); }
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
  methods: {
    toggleRules: function () { this.$data.rulesDialog = !this.$data.rulesDialog; },
    load: async function () {
      this.isLoading = true;

      const response = await workflowService.getChangeKennelOwnerRequestDetailsForSignature(this.signatureId);

      this.errorMessage = "";
      this.found = response.found;

      if (response.found && (!response.errors || response.errors.length == 0)) {
        this.registration = response.data;
      } else if (!!response.errors) this.errorMessage = response.errors ? response.errors.join(',') : 'An Unknown Error Occured'

      this.isLoading = false;
    },
    sign: function (workflowGuid: String, signatureId: number, personId: number, text: String) {
      workflowService
        .signChangeKennelOwnerRequest(workflowGuid, signatureId, personId, text)
        .then((res) => {
          this.$store.dispatch("loadPersonTasks", this.userInfo.personId);
          this.$router.push("/");
        }).catch((e) => this.$router.push("/"));
    },
  },
});
